import { FC } from "react";

import { ModalProps } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { ActionButton } from '@hdi-seguros/web-components.action-button';
import { Card } from "@hdi-seguros/web-components.card";
import { Modal } from '@hdi-seguros/web-components.modal';

import { Payment } from "../../../../../shared/interfaces";
import { formatDate } from "../../../../../shared/utils";
import { Column, _renderColumns } from "../../utils/renderSections";

import './index.css';
import { RowSize } from "../../../../../shared/components";
import { allowDownloadReceiptPayment, getCompensationReceiptPDF } from "../../../../sinister/NewComplaint/shared/utils/compensation-receipt-pdf";

interface PaymentsModalProps extends ModalProps {
    payments: Array<Payment>;
}

export const PaymentsModal: FC<PaymentsModalProps> = ({ open, title, onCancel, payments }) => {

    const generatePaymentInfo = ( { fechaLiq, importePago, tipoBen, tipoPago, cobertura, fechaPago, nroOdp, nroRecibo, beneficiario }: Payment ): Array<Column> => [
        {
            label: 'Fecha de liquidación',
            value: formatDate( fechaLiq ),
            columnSize: { xs: { span: 12 }, sm: { span: 6 }, md: { span: 5 } },
        },
        {
            label: 'Importe',
            value: importePago,
            columnSize: { xs: { span: 12 }, sm: { span: 6 }, md: { span: 4 } },
        },
        {
            label: 'Tipo beneficiario',
            value: tipoBen,
            columnSize: { xs: { span: 12 }, sm: { span: 6 }, md: { span: 5 } },
        },
        {
            label: 'Beneficiario',
            value: beneficiario,
            columnSize: { xs: { span: 12 }, sm: { span: 6 }, md: { span: 6 } },
        },
        {
            label: 'Tipo de pago',
            value: tipoPago,
            columnSize: { xs: { span: 12 }, sm: { span: 6 }, md: { span: 4 } },
        },
        {
            label: 'Cobertura',
            value: cobertura,
            columnSize: { xs: { span: 12 }, sm: { span: 6 }, md: { span: 5 } },
        },
        {
            label: 'Fecha de pago',
            value: fechaPago,
            columnSize: { xs: { span: 12 }, sm: { span: 6 }, md: { span: 4 } },
        },
        {
            label: 'Número de orden de pago',
            value: nroOdp,
            columnSize: { xs: { span: 12 }, sm: { span: 6 }, md: { span: 5 } },
        },
        {
            label: 'Recibo Indemnización',
            value: allowDownloadReceiptPayment(nroRecibo) ? (<ActionButton className="btn-accent-outline-barbuss" type="secondary" label="Descargar" onClick={() => getCompensationReceiptPDF(nroOdp)} icon={<DownloadOutlined />} />) : 'No',
            columnSize: { xs: { span: 12 }, sm: { span: 6 }, md: { span: 6 } },
        },
    ]; 

    return (
        <Modal
            title={ title }
            centered
            open={ open }
            width={1000}
            onCancel={ onCancel }
        >
            {
                payments.map(( payment, i ) => (
                    <Card
                        key={ i }
                        style={{ marginBottom: 20 }}
                    >
                        <RowSize rowProps={{gutter:[0 , 15]}} >
                            { _renderColumns( generatePaymentInfo( payment ) ) }
                        </RowSize>
                    </Card>
                ))
            }
        </Modal>
    )
}
